import React from 'react';
import {observer} from 'mobx-react';
import {Input, FormLayout, Panel} from 'shared/components';
import {t} from 'shared/core';

const PolicyDetails = observer(({uiState}) => {
  const {policy, errors} = uiState;

  return (
    <>
      <Panel.Header
        title={t('expenses.manage.policies.edit.Policy Details')}
        description={t('expenses.manage.policies.edit.Set up the basic details of your expense policy.')}
      />
      <FormLayout>
        <Input
          value={policy.name}
          label='expenses.manage.policies.edit.Policy Name'
          onChange={e => policy.merge({name: e.target.value})}
          errorMessage={errors.name}
        />
      </FormLayout>
    </>
  );
});

export default PolicyDetails;
